import APIService from '@/services/APIService.js';

export default {
  getLogs(all) {
    return APIService.apiCall().get(`/logsAplicacao/getLogs/${all}`);
  }
};
